import React, { useState,  } from 'react'
import { Stack, Zoom, SvgIconProps } from '@mui/material'
import { Menu as MenuIcon, SvgIconComponent } from '@mui/icons-material'

import { Box } from '@mui/material'
import BottomBarIconButton from './BottomBarIconButton'

export type ExpandableMenuItem = {
  id: string
  label: string
  icon: SvgIconComponent | ((props: SvgIconProps & { children?: React.ReactNode }) => JSX.Element)
  isNested?: boolean
}

type ExpandableMenuProps = {
  items: ExpandableMenuItem[]
  onClick: (id: string) => void
  sx?: any
}

function ExpandableMenu(props: ExpandableMenuProps) {
  const { items, onClick } = props
  const [open, setOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState(items[0].id)

  const handleToggle = () => {
    setOpen(!open)
  }

  const handleItemClick = (id: string) => {
    setSelectedItem(id)
    setOpen(false)
    onClick(id)
  }

  return (
    <>
      <Stack direction="column" spacing={1} alignItems="center">
        <Box
          sx={{
            ...props.sx,
            position: 'absolute',
            right: '50%',
            transform: 'translateX(50%)',
            bottom: '66px',
          }}
        >
          <Zoom in={open}>
            <Stack
              direction="row"
              sx={{
                backgroundColor: 'white',
                borderRadius: '25px',
                boxShadow: '4',
                padding: '10px',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              spacing={2}
            >
              {items.map((item, index) => (
                <Zoom key={index} in={open} style={{ transitionDelay: `${open ? index * 100 : 0}ms` }}>
                  <BottomBarIconButton icon={item.icon} label={item.label} onClick={() => handleItemClick(item.id)} selected={selectedItem === item.id} />
                </Zoom>
              ))}
            </Stack>
          </Zoom>
        </Box>
      </Stack>
      <BottomBarIconButton icon={MenuIcon} label="Menu" onClick={handleToggle} selected={open} />
    </>
  )
}
export default ExpandableMenu
